import{__awaiter as e}from"../../../../../node_modules/tslib/tslib.es6.js";import{shopifyStorefrontClientWrapper as i}from"../../../../../lib/clients.js";import{handleError as t}from"../../../../../lib/error-handler.js";import{gql as n}from"graphql-request";import{shopifyCollectionToUnlikelyCollection as l}from"../utils/serializers.js";import{STOREFRONT_IMAGE_FRAGMENT as d}from"../../fragments/image.js";import{STOREFRONT_MEDIA_FRAGMENT as r}from"../../fragments/media.js";import{STOREFRONT_METAFIELD_FRAGMENT as o}from"../../fragments/metafields.js";import{PAGE_INFO_FRAGMENT as s}from"../../fragments/page-info.js";import{STOREFRONT_PRICE_FRAGMENT as a}from"../../fragments/price.js";import{STOREFRONT_PRICE_RANGE_FRAGMENT as c}from"../../fragments/price-range.js";import{STOREFRONT_STORE_AVAILABILITY_FRAGMENT as u}from"../../fragments/store-availability.js";import{getMetafieldIdentifiers as f}from"../../../../../lib/metafields.js";import{STOREFRONT_VARIANT_COMPONENTS_FRAGMENT as m}from"../../fragments/variant-components.js";const $=n`
  query Collection(
    $handle: String
    $id: ID
    $includeImage: Boolean!
    $includeSeo: Boolean!
    $includeDescriptions: Boolean!
    $language: LanguageCode
    $country: CountryCode
    $includeMetafields: Boolean!
    $metafieldIdentifiers: [HasMetafieldsIdentifier!]!
    # products
    $includeProducts: Boolean!
    $productsFirst: Int
    $productsLast: Int
    $productsAfter: String
    $productsBefore: String
    $productsSortKey: ProductCollectionSortKeys
    $productReverse: Boolean!
    $includeProductMedia: Boolean!
    $productMediaFirst: Int
    $includeFeaturedImage: Boolean!
    $includePrices: Boolean!
    $imagesFirst: Int
    $includeImages: Boolean!
    $includeProductsTags: Boolean!
    $collectionsFirst: Int
    $includeCollections: Boolean!
    $variantsFirst: Int
    $includeVariants: Boolean!
    $includeProductsMetafields: Boolean!
    $metafieldProductsIdentifiers: [HasMetafieldsIdentifier!]!
    $includeCollectionsMetafields: Boolean!
    $storeAvailabilityFirst: Int,
    $includeStoreAvailability: Boolean!,
    $metafieldCollectionsIdentifiers: [HasMetafieldsIdentifier!]!
    $includeProductsFilters: Boolean!
    $productsFilters: [ProductFilter!]
    $includeVariantsMetafields: Boolean!
    $metafieldVariantsIdentifiers: [HasMetafieldsIdentifier!]!
    $includeVariantComponents: Boolean!
    $variantComponentsFirst: Int
    $metafieldVariantComponentIdentifiers: [HasMetafieldsIdentifier!]!
    $includeMetafieldVariantComponentIdentifiers: Boolean!
    $metafieldVariantComponentProductIdentifiers: [HasMetafieldsIdentifier!]!
    $includeMetafieldVariantComponentProductIdentifiers: Boolean!
    $includeVariantComponentImage: Boolean!
  ) @inContext(language: $language, country: $country) {
    collection(handle: $handle, id: $id) {
      id
      title
      handle
      description @include(if: $includeDescriptions)
      descriptionHtml @include(if: $includeDescriptions)
      image @include(if: $includeImage) {
        ${d}
      }
      seo @include(if: $includeSeo) {
        title
        description
      }
      metafields(identifiers: $metafieldIdentifiers) @include(if: $includeMetafields) {
        ${o}
      }
      updatedAt

      products(first: $productsFirst, after: $productsAfter, last: $productsLast, before: $productsBefore, filters: $productsFilters, sortKey: $productsSortKey, reverse: $productReverse) @include(if: $includeProducts) {
        filters @include(if: $includeProductsFilters) {
          id
          label
          values {
              label
              count
              id
              input
              swatch {
                  color
              }
          }
        }
        nodes {
          id
          title
          handle
          publishedAt
          createdAt
          updatedAt
          productType
          vendor
          isGiftCard
          description
          descriptionHtml
          availableForSale
          featuredImage @include(if: $includeFeaturedImage) {
            ${d}
          }

          compareAtPriceRange @include(if: $includePrices) {
            ${c}
          }

          priceRange @include(if: $includePrices) {
            ${c}
          }

          images(first: $imagesFirst) @include(if: $includeImages) {
            nodes {
              ${d}
            }
          }

          media(first: $productMediaFirst) @include(if: $includeProductMedia) {
            nodes {
              ${r}
            }
          }

          metafields(identifiers: $metafieldProductsIdentifiers) @include(if: $includeProductsMetafields) {
            ${o}
          }

          tags @include(if: $includeProductsTags)

          variants(first: $variantsFirst) @include(if: $includeVariants) {
            nodes {
              id
              sku
              title
              availableForSale
              quantityAvailable
              price @include(if: $includePrices) {
                ${a}
              }

              image {
                ${d}
              }

              storeAvailability(first: $storeAvailabilityFirst) @include(if: $includeStoreAvailability) {
                ${u}
              }

              compareAtPrice @include(if: $includePrices) {
                ${a}
              }

              selectedOptions {
                name
                value
              }

              metafields(identifiers: $metafieldVariantsIdentifiers) @include(if: $includeVariantsMetafields) {
                ${o}
              }

              components(first: $variantComponentsFirst) @include(if: $includeVariantComponents) {
                ${m}
              }
            }
          }

          collections(first: $collectionsFirst) @include(if: $includeCollections){
            nodes {
              id
              handle
              title
              metafields(identifiers: $metafieldCollectionsIdentifiers) @include(if: $includeCollectionsMetafields) {
                ${o}
              }
            }
          }
        }
        ${s}
      }
    }
  }
`,p=i(((i,n)=>e(void 0,void 0,void 0,(function*(){var e,d,r,o,s,a,c,u,m,p,g,v;const{includeImage:I=!1,includeVariantComponentImage:F=!1,includeSeo:C=!0,includeDescriptions:P=!0,metafieldKeys:y,language:M,country:B,productMediaFirst:V=0,storeAvailabilityFirst:b=0}=null!=n?n:{},h="handle"in n?{handle:n.handle}:{id:n.id},A=f(y),S=f(n.metafieldProductsKeys),j=f(n.metafieldCollectionsKeys),K=f(n.metafieldVariantsKeys),H=f(n.variantComponentMetafieldKeys),D=f(n.variantComponentProductMetafieldKeys),L=V>0,R=b>0,q=yield i.request($,Object.assign(Object.assign({},h),{language:M,country:B,includeImage:I,includeSeo:C,includeDescriptions:P,includeMetafields:A.length>0,metafieldIdentifiers:A,includeProducts:(null!==(e=n.productsFirst)&&void 0!==e?e:0)>0||(null!==(d=n.productsLast)&&void 0!==d?d:0)>0,productsFirst:n.productsFirst,productsAfter:n.productsAfter,productsLast:n.productsLast,productsBefore:n.productsBefore,productsSortKey:n.productsSortKey,productReverse:null!==(r=n.productReverse)&&void 0!==r&&r,includeStoreAvailability:null!=R&&R,storeAvailabilityFirst:b,includeProductMedia:null!=L&&L,productMediaFirst:V,includePrices:null!==(o=n.includePrices)&&void 0!==o&&o,includeFeaturedImage:null!==(s=n.includeFeaturedImage)&&void 0!==s&&s,imagesFirst:n.imagesFirst,includeImages:(null!==(a=n.imagesFirst)&&void 0!==a?a:0)>0,collectionsFirst:n.collectionsFirst,includeCollections:(null!==(c=n.collectionsFirst)&&void 0!==c?c:0)>0,variantsFirst:n.variantsFirst,includeVariants:(null!==(u=n.variantsFirst)&&void 0!==u?u:0)>0,includeProductsMetafields:S.length>0,includeProductsTags:null!==(m=n.includeProductsTags)&&void 0!==m&&m,includeProductsFilters:null!==(p=n.includeProductsFilters)&&void 0!==p&&p,productsFilters:null!==(g=n.productsFilters)&&void 0!==g?g:[],metafieldProductsIdentifiers:S,includeCollectionsMetafields:j.length>0,metafieldCollectionsIdentifiers:j,includeVariantsMetafields:K.length>0,metafieldVariantsIdentifiers:K,variantComponentsFirst:n.variantComponentsFirst,includeVariantComponents:(null!==(v=n.variantComponentsFirst)&&void 0!==v?v:0)>0,includeVariantComponentImage:F,metafieldVariantComponentIdentifiers:H,metafieldVariantComponentProductIdentifiers:D,includeMetafieldVariantComponentProductIdentifiers:(null==D?void 0:D.length)>0,includeMetafieldVariantComponentIdentifiers:(null==H?void 0:H.length)>0}));return{errors:t(null==q?void 0:q.errors),collection:(null==q?void 0:q.collection)?l(q.collection):null}}))));export{p as sfCollection};
//# sourceMappingURL=collection.js.map
